// Actiondan gelen datalar ile stateler güncellenecek
export const warehouseLoading = (state, payload) => {
  state.loading = payload
}

export const warehouseStatus = (state, payload) => {
  state.warehouseStatus = payload
}

export const warehouses = (state, payload) => {
  state.warehouses = payload.data ? payload.data : []
}

export const warehouseProducts = (state, payload) => {
  state.warehouseProducts = payload.data ? payload.data : []
}



// WEBPACK FOOTER //
// ./src/store/modules/Warehouse/Mutations.js